import { Transforms, Path } from 'slate';
import { ReactEditor } from 'slate-react';

import HelptapEditor from '../';

export function insertNode(editor) {

  const mention = {
    type: 'mention',
    mentionOptions: {
      selected: false,
      data: null,
      searchText: null
    },
    children: [{ text: '' }]
  };

  Transforms.insertNodes(editor, mention);

}

export function add(editor, mentionOptions, data, elementPath) {

  const mentionLabel = `@${data.label}`;

  // updating latest attributes
  HelptapEditor.setAttributes(editor, {
    mentionOptions: {
      ...mentionOptions,
      selected: true,
      data
    }
  }, elementPath);

  // Inserting mention label as text node in the "mention" node
  Transforms.insertText(editor, mentionLabel, {
    at: elementPath
  });

  // Whenever any inline node is inserted, "slate" inserts a "text" node, before and after the inline node, automatically.
  // Selecting the "text" node that comes after the "mention" node
  Transforms.select(editor, {
    anchor: {
      path: Path.next(elementPath),
      offset: 0
    },
    focus: {
      path: Path.next(elementPath),
      offset: 0
    }
  });

  // For UX, adding a space in the "text" node that comes after "mention" node
  Transforms.insertText(editor, ' ');

  // Placing cursor on the "text" node that comes after "mention" node
  ReactEditor.focus(editor);

}

export function unwrapNode(editor, text, elementPath) {

  Transforms.insertText(editor, text, {
    at: elementPath
  });

  Transforms.unwrapNodes(editor, { at: elementPath });

  // Move the cursor to the end of the selection
  Transforms.collapse(editor, { edge: 'end' });

  ReactEditor.focus(editor);

}
